export const getValidStr = (str, type) => (type ? str + type : null);
